import React, { useRef, useState, useContext, useEffect } from "react";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Templete from "../Templete/Templete";

import AuthService from "../../../services/Admin/AuthService";
import LeadManagementService from "../../../services/Admin/LeadManagementService";
import PackageService from "../../../services/Admin/PackageService";
import HttpError from "../../../utill/HttpError";
import LoadingContext from "../../../store/loading-context";
import { states } from "../../../utill/Common";

const AddLeadProduct = () => {
  const loadingCtx = useContext(LoadingContext);

  React.useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [leadCategories, setLeadCategories] = useState();

  const [categoryId, setCategoryId] = useState();
  const [status, setStatus] = useState();
  const [payoutType, setPayoutType] = useState();
  const [sourceType, setSourceType] = useState();
  const [utmFetchType, setUtmFetchType] = useState();

  const formRef = useRef();
  const nameRef = useRef();
  const titleRef = useRef();
  const subTitleRef = useRef();
  const logoRef = useRef();
  const earnUptoRef = useRef();

  const baseEarningRef = useRef();
  const baseEarningNoteRef = useRef();

  const bonusEarningRef = useRef();
  const bonusEarningNoteRef = useRef();

  const dataRef = useRef();

  const utmLinkRef = useRef();

  const banksathiConfigRef = useRef();

  const submitHandler = async () => {
    const name = nameRef.current.value;
    const title = titleRef.current.value;
    const subTitle = subTitleRef.current.value;
    const logo = logoRef.current.value;
    const earnUpto = earnUptoRef.current.value;

    const baseEarning = baseEarningRef.current.value;
    const baseEarningNote = baseEarningNoteRef.current.value;

    const bonusEarning = bonusEarningRef.current.value;
    const bonusEarningNote = bonusEarningNoteRef.current.value;

    const data = dataRef.current.value;
    const utmLink = utmLinkRef.current.value;
    const banksathiConfig = banksathiConfigRef.current.value;

    if (!name) {
      Swal.fire("Opps!", "Invalid Name", "error");
      return;
    }

    if (!title) {
      Swal.fire("Opps!", "Invalid Title", "error");
      return;
    }

    if (!subTitle) {
      Swal.fire("Opps!", "Invalid Sub Title", "error");
      return;
    }

    if (!logo) {
      Swal.fire("Opps!", "Invalid Logo", "error");
      return;
    }

    if (!earnUpto) {
      Swal.fire("Opps!", "Invalid Earn Upto", "error");
      return;
    }

    if (!data) {
      Swal.fire("Opps!", "Invalid Data", "error");
      return;
    }

    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await LeadManagementService.addLeadProduct(
        token,
        categoryId,
        name,
        title,
        subTitle,
        logo,
        payoutType,
        earnUpto,
        baseEarning,
        baseEarningNote,
        bonusEarning,
        bonusEarningNote,
        data,
        status,
        sourceType,
        utmFetchType,
        utmLink,
        banksathiConfig
      );
      const status1 = responseData.status;
      const message = responseData.message;

      if (status1 === "SUCCESS") {
        formRef.current.reset();
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  const fetchCategories = async () => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await LeadManagementService.fetchCategories(token);

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setLeadCategories(responseData.data);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  return (
    <React.Fragment>
      <Templete t1="Home" t2="Add Lead Product">
        <section class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-primary">
                  <div class="card-header">
                    <h3 class="card-title">Add Lead Product</h3>
                  </div>

                  <div class="row">
                    <div class="col-md-12 mx-auto">
                      <form ref={formRef} autoComplete="off">
                        <div class="card-body mt-2 mb-2">
                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Select Category
                            </label>
                            <div class="col-sm-10">
                              <Autocomplete
                                options={leadCategories}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Select Category"
                                  />
                                )}
                                onChange={(e, v) => {
                                  setCategoryId(v ? v.id : null);
                                }}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Name</label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Name"
                                ref={nameRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Title</label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Title"
                                ref={titleRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Sub Title
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Title"
                                ref={subTitleRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Logo</label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Logo"
                                ref={logoRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Payout Type
                            </label>
                            <div class="col-sm-10">
                              <select
                                name="title"
                                class="form-control"
                                onChange={(e) => {
                                  setPayoutType(e.target.value);
                                }}
                              >
                                <option value="FLAT">FLAT</option>
                                <option value="PERCENTAGE">PERCENTAGE</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Earn Upto
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Earn Upto"
                                ref={earnUptoRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Base Earning
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Base Earning"
                                ref={baseEarningRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Base Earning Note
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Base Earning Note"
                                ref={baseEarningNoteRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Bonus Earning
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Bonus Earning"
                                ref={bonusEarningRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Bonus Earning Note
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Bonus Earning Note"
                                ref={bonusEarningNoteRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Data</label>
                            <div class="col-sm-10">
                              <textarea
                                class="form-control"
                                ref={dataRef}
                                cols="50"
                                rows="30"
                              ></textarea>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Status
                            </label>
                            <div class="col-sm-10">
                              <select
                                name="title"
                                class="form-control"
                                onChange={(e) => {
                                  setStatus(e.target.value);
                                }}
                              >
                                <option value="">---Select Status---</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                                <option value="Paused">Paused</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              Source Type
                            </label>
                            <div class="col-sm-10">
                              <select
                                name="title"
                                class="form-control"
                                onChange={(e) => {
                                  setSourceType(e.target.value);
                                }}
                              >
                                <option value="">
                                  ---Select Source Type---
                                </option>
                                <option value="DIRECT">DIRECT</option>
                                <option value="BANKSATHI">BANKSATHI</option>
                                <option value="CASHKARO">CASHKARO</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              UTM Fetch Type
                            </label>
                            <div class="col-sm-10">
                              <select
                                name="title"
                                class="form-control"
                                onChange={(e) => {
                                  setUtmFetchType(e.target.value);
                                }}
                              >
                                <option value="">
                                  ---Select UTM Fetch Type---
                                </option>
                                <option value="STATIC">STATIC</option>
                                <option value="API">API</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              UTM Link
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder=" UTM Link"
                                ref={utmLinkRef}
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-sm-2 col-form-label">
                              BANKSATHI CONFIG
                            </label>
                            <div class="col-sm-10">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="BANKSATHI CONFIG"
                                ref={banksathiConfigRef}
                              />
                            </div>
                          </div>

                          <div class="card-footer text-center">
                            <button
                              type="button"
                              class="btn btn-primary"
                              onClick={submitHandler}
                            >
                              Submit
                            </button>
                            <button type="reset" class="btn btn-default ml-5">
                              Reset
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Templete>
    </React.Fragment>
  );
};

export default AddLeadProduct;
